// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__q8KDY","title":"FrontImage_title__3kSWU"};